import { render, staticRenderFns } from "./ModalCreateFamily.vue?vue&type=template&id=5bd695f0"
import script from "./ModalCreateFamily.vue?vue&type=script&lang=js"
export * from "./ModalCreateFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports